export default "__VITE_ASSET__CsneTC98__"